module.exports = __webpack_public_path__ + "img/showmorw05.dabf077.png";